import { Box, useTheme } from '@material-ui/core'
import useMediaQuery from '@mui/material/useMediaQuery'

import { FILTER_SPYPOINT_ICON_BY_KEY } from '../core/spypointFilters.types'
import SpypointFilterCategory from './SpypointFilterCategory'
import SpypointFilterItem from './SpypointFilterItem'
import SpyPointDateRangeFilterButton from './SpyPointDateRangeFilterButton'
import { useLDFlags } from 'spypoint/src/launchDarkly-module/launchDarklyFlagsContext'

const SpypointFilterList = ({
  filterKeys,
  filterValues,
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const { flags } = useLDFlags()
  const isDateRangeEnabled = flags && flags['date-range-filter']
  const isDayNightEnabled = flags && flags['day-and-night']

  const renderFilterItems = () => {
    return filterValues && filterValues?.map((filterValue, index) => {
      if (!isDayNightEnabled && filterValue[0] === 'day' && filterValue[1] === 'night') {
        return
      }
      return filterValue?.length === 1
        ? (
          <SpypointFilterItem
            key={filterValue}
            // Icon={FILTER_SPYPOINT_ICON_BY_KEY[filterKeys[index]]}
            hasCategory={false}
            label={filterValue[0]}
          />
          )
        : (
          <SpypointFilterCategory
            key={filterValue}
            // Icon={FILTER_SPYPOINT_ICON_BY_KEY[filterKeys[index]]}
            label={filterKeys[index]}
            values={filterValue}
          />
          )
    })
  }

  return (
    <Box display="flex" flexWrap="wrap" alignItems="center" margin="10px 20px 10px">
      { /* On mobile, show date range filter first */ }
      { isDateRangeEnabled && isMobile && <SpyPointDateRangeFilterButton /> }

      { renderFilterItems() }

      { /* On desktop, show date range filter last */ }
      { isDateRangeEnabled && !isMobile && <SpyPointDateRangeFilterButton /> }
    </Box>
  )
}

export default SpypointFilterList
